import MuiLink from "@mui/material/Link";
import PropTypes from "prop-types";

import PurchaseOrderChip from "../../../buttons/purchaseOrderChip";

const HeaderPOValue = ({ req, onMultipleClick }) => {
    const poNumbers = req?.PO_NUMBERS
        ? req?.PO_NUMBERS.constructor == Array
            ? req.PO_NUMBERS
            : []
        : [];
    if (poNumbers.length == 0) {
        return "N/A";
    } else if (poNumbers.length == 1) {
        return (
            <PurchaseOrderChip
                // Include `ORG_ID` so the chip's link deep-links with
                // `?org_id=…` and `PoSummaryPage` skips the OU chooser
                // (the req row is already OU-scoped — the chooser would
                // be a no-op here).
                data={{
                    PO_NUMBER: poNumbers[0],
                    ORG_ID: req?.requisitionHeaderForm?.ORG_ID,
                }}
                variant="minimal"
            />
        );
    } else {
        return (
            <MuiLink
                component="button"
                color="secondary"
                onClick={onMultipleClick}
            >
                MULTIPLE
            </MuiLink>
        );
    }
};

HeaderPOValue.propTypes = {
    req: PropTypes.object.isRequired,
    onMultipleClick: PropTypes.func.isRequired,
};

export default HeaderPOValue;
